import React from 'react';
import { FaYoutube, FaInstagram, FaFacebook, FaTwitter, FaTiktok, FaLinkedin, FaWhatsapp, FaLink } from 'react-icons/fa';

const IconRenderer = ({ type, size = 24, className = '' }) => {
  const iconMap = {
    youtube: FaYoutube,
    instagram: FaInstagram,
    facebook: FaFacebook,
    twitter: FaTwitter,
    tiktok: FaTiktok,
    linkedin: FaLinkedin,
    whatsapp: FaWhatsapp,
    custom: FaLink,
  };

  const Icon = iconMap[type?.toLowerCase()] || FaLink;

  return <Icon size={size} className={className} />;
};

export default IconRenderer;
